import { useContext } from 'react';

import { CanvasContext } from './canvasContext';
import type { CanvasContextValue } from './CanvasProvider';

export function useCanvas(): CanvasContextValue {
  const ctx = useContext(CanvasContext);
  if (!ctx) {
    throw new Error('useCanvas must be used within CanvasProvider');
  }
  return ctx;
}

export type { CanvasContextValue };
